import cookies from 'js-cookie'
import http from '@/plugins/http'
import router from '@/router/index'
import { isString } from 'lodash'
import { changePrivinceCodeToCityCode } from '@/utils/cityPollyfill'

export const CITY_COOKIE = 'city_service'

export const defaultCity = {
  cityId: '320100',
  cityName: '南京'
}

async function getCityNameByCityId(cityId) {
  const response = await http.get(
    '//address.cekid.com/addressview/GetNameById' + '?addressId=' + cityId
  )
  if (response && response.RetCode * 1 === 0) {
    const ro = response.Result
    return ro.NAME
  } else {
    return ''
  }
}

//chooseCityFirst是否优先取city
export async function getSelectedCity(chooseCityFirst = true) {
  const currentRoute = router.currentRoute
  const query = currentRoute.query
  const isSelected = (query && query.swt === '1') || chooseCityFirst
  let cityId = ''
  let cityName = ''
  // const cityIdCityName = cookies.get('city')
  const cityIdCityName = cookies.get(CITY_COOKIE)
  if (isSelected && cityIdCityName) {
    if (isString(cityIdCityName)) {
      const iNList = cityIdCityName.split('_')
      cityId = iNList[0]
      cityName = iNList[1]
      if (cityId && !cityName) {
        cityName = await getCityNameByCityId(cityId)
      }
      cityName = cityName.replace('市', '')
      return {
        cityId,
        cityName
      }
    }
  } else {
    cityId = cookies.get('citycode') || ''
    console.log('cityId', cityId)
    if (cityId) {
      cityName = await getCityNameByCityId(cityId)
    }
    cityName = cityName.replace('市', '')
    // return {
    //   cityId,
    //   cityName
    // }
  }
  if (cityId && cityName) {
    cityId = changePrivinceCodeToCityCode(cityId)
    return {
      cityId: cityId.toString(),
      cityName
    }
  } else {
    return defaultCity
  }
}
